var SelectModule = require('../modules/select')

var Module = {
    name: 'countries',
    selectors: {
        select2: '#countriesList',
        select2Fake: '#countriesListFake',
        select2CustomPhone: '#countriesList-phone-mask',
    },
    isPreSelected: false,
    isPhoneMaskPreSelected: false,

    init: function (eventID = '', phoneMaskCountry = false) {
        Module.select2Init(eventID, phoneMaskCountry ? '-phone-mask' : '');
        if (!eventID) {
            $(document).on('LocationDetector:detected', Module.onLocationCountryDetected);
        }
    },

    select2Init: function (eventID = '', phoneMaskCountry = '') {
        let options = allCountries;

        if (eventID) {
            var select = $('[data-event-id="'+eventID+'"][data-name="country_id"]');
        } else if (phoneMaskCountry) {
            var select = $(document).find(Module.selectors.select2CustomPhone);
            options = allCountries.map(function(country) {
                return {
                    id: country.id,
                    code: country.code,
                    text: '<img src="'+$('meta[name="app-url"]').attr('content') +
                        '/images/flags/' + country.code.toLowerCase() + '.svg"/> ' + country.text,
                }
            });
            Module.isPhoneMaskPreSelected = select.val();
        } else {
            var select = $(document).find(Module.selectors.select2);
            Module.isPreSelected = select.val();
        }

        SelectModule.init($(document).find(Module.selectors.select2Fake), options)

        if (select.length) {
            const selectParent = select.parent('.form-group');

            SelectModule.init(select, options).on('select2:select', function (e) {
                selectParent.removeClass('has-error')
                let option = $(e.params.data.element);

                if (option.val() !== '') {
                    selectParent.children('label').addClass('active')
                } else {
                    selectParent.children('label').removeClass('active')
                }

                $.event.trigger({type: Module.name + eventID + phoneMaskCountry + ':changed', countryData: e.params.data});
            });

            let preSelectCountry = options.find(function(country) {
                return country.id == select.val();
            });
            $.event.trigger({
                type: Module.name + eventID + phoneMaskCountry + ':init',
                countryData: {
                    id: (preSelectCountry)? preSelectCountry.id : null,
                    code: (preSelectCountry)? preSelectCountry.code : null,
                    states_count: (preSelectCountry)? preSelectCountry.states_count : null,
                }
            })
        }
    },

    onLocationCountryDetected(event, countryCode) {
        if (Module.isPreSelected) {
            return;
        }

        const detectedCountry = allCountries.find(function (c) {
            return c.code === countryCode;
        });

        if (detectedCountry) {
            // Mark that location detector triggers now processing to prevent analytics
            window.isLocationDetectedTriggers = true;

            $(document).find(Module.selectors.select2).val(detectedCountry.id).trigger('change');
            $.event.trigger({type: 'countries:changed', countryData: detectedCountry});

            if ($('#countriesList-phone-mask').length > 0) {
                $(document).find(Module.selectors.select2CustomPhone).val(detectedCountry.id).trigger('change');
                $.event.trigger({type: 'countries-phone-mask:changed', countryData: detectedCountry});
            }

            // Mark that location detector triggers completed
            setTimeout(() => window.isLocationDetectedTriggers = false, 100);
        }
    }
}

module.exports = Module
